import { useQuery } from '@apollo/client';
import { get } from 'lodash';
import GET_MERGED_PRACTICE_AREAS from '../queries/getMergedPracticeAreasQuery';

const useMddapPracticeAreas = () => {
  const { loading, data, error } = useQuery(GET_MERGED_PRACTICE_AREAS);

  return { loading, data: get(data, 'practiceAreasMerged', []), error };
};

export default useMddapPracticeAreas;
